export default "__VITE_ASSET__CVhLLXHa__"